import { extendTheme } from "@chakra-ui/react";

const breakpoints = {
  sm: "540px",
  md: "768px",
  lg: "1024px",
  xl: "1200px",
  "2xl": "1400px",
};

const inputStyles = {
  height: { base: "44px", md: "46px" },
  borderRadius: "10px",
  border: "1.5px solid",
  borderColor: "gray.200",
  bg: "white",
  fontSize: { base: "16px", md: "14px" },
  transition: "border-color 0.2s ease, box-shadow 0.2s ease",
  _placeholder: { color: "gray.400" },
  _hover: { borderColor: "gray.300" },
  _focus: {
    borderColor: "blue.400",
    boxShadow: "0 0 0 3px rgba(66, 153, 225, 0.15)",
  },
  _disabled: {
    bg: "gray.50",
    borderColor: "gray.200",
    opacity: 1,
    cursor: "not-allowed",
  },
};

export const theme = extendTheme({
  colors: {
    lightGreen: {
      50: "#E5FE9D",
      100: "#E5FE9D",
      500: "#E5FE9D",
    },
    lightBlue: {
      50: "#0D99FF",
      100: "#0D99FF",
      500: "#0D99FF",
    },
    auth: {
      bg: "#FFFFFF",
      bgAccent: "#FFFFFF",
      card: "#FFFFFF",
      text: "#1A202C",
      muted: "#718096",
      border: "rgba(0, 0, 0, 0.06)",
    },
  },
  shadows: {
    authCard: "0 8px 40px rgba(15, 23, 42, 0.08), 0 2px 8px rgba(15, 23, 42, 0.04)",
    authCardHover: "0 12px 48px rgba(15, 23, 42, 0.12), 0 4px 12px rgba(15, 23, 42, 0.06)",
  },
  styles: {
    global: {
      html: {
        WebkitTapHighlightColor: "transparent",
      },
      body: {
        fontWeight: "400",
        color: "auth.text",
        bg: "auth.bg",
        minHeight: "100dvh",
      },
      "*": {
        lineHeight: 1.5,
        "&::-webkit-scrollbar": { width: "6px" },
        "&::-webkit-scrollbar-track": { width: "6px" },
        "&::-webkit-scrollbar-thumb": {
          background: "#CBD5E0",
          borderRadius: "24px",
        },
      },
    },
  },
  components: {
    Modal: {
      sizes: { "700px": "700px" },
    },
    Button: {
      baseStyle: {
        lineHeight: 1.5,
        fontSize: "14px",
        fontWeight: 500,
        height: "auto",
        borderRadius: "10px",
      },
      variants: {
        authPrimary: {
          w: "100%",
          h: { base: "50px", md: "48px" },
          borderRadius: "full",
          fontWeight: 600,
          fontSize: { base: "16px", md: "15px" },
          color: "white",
          transition: "opacity 0.2s ease, transform 0.15s ease, box-shadow 0.2s ease",
          _hover: {
            opacity: 0.94,
            transform: "translateY(-1px)",
            boxShadow: "md",
          },
          _active: { transform: "translateY(0)" },
        },
        authOutline: {
          h: { base: "50px", md: "48px" },
          minW: "150px",
          px: 6,
          borderRadius: "full",
          fontWeight: 600,
          fontSize: { base: "16px", md: "15px" },
          color: "white",
          border: "2px solid white",
          bg: "transparent",
          transition: "background 0.2s ease, transform 0.15s ease",
          _hover: { bg: "whiteAlpha.200", transform: "translateY(-1px)" },
          _active: { transform: "translateY(0)" },
        },
        authGhost: {
          h: "32px",
          fontSize: "13px",
          fontWeight: 500,
          color: "gray.500",
          _hover: { bg: "gray.100", color: "gray.700" },
        },
        authGoogle: {
          w: "100%",
          h: { base: "50px", md: "46px" },
          borderRadius: "full",
          fontWeight: 500,
          fontSize: { base: "15px", md: "14px" },
          bg: "white",
          border: "1.5px solid",
          borderColor: "gray.200",
          color: "gray.700",
          transition: "border-color 0.2s ease, box-shadow 0.2s ease, transform 0.15s ease",
          _hover: {
            borderColor: "gray.300",
            boxShadow: "sm",
            transform: "translateY(-1px)",
          },
          _active: { transform: "translateY(0)" },
        },
      },
    },
    Input: {
      variants: {
        outline: inputStyles,
      },
      defaultProps: { variant: "outline" },
    },
    FormLabel: {
      baseStyle: {
        fontSize: { base: "14px", md: "13px" },
        fontWeight: 500,
        color: "gray.600",
        mb: "6px",
      },
    },
    Heading: {
      baseStyle: {
        lineHeight: 1.3,
      },
    },
  },
  breakpoints,
});
